// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"PrimaryButton_primaryButton__33L35","primaryButtonLight":"PrimaryButton_primaryButtonLight__1BWgE","primaryButtonDark":"PrimaryButton_primaryButtonDark__3xWA8"};